import { useEffect, useRef } from 'react'
import './geometric-shapes.scss'

interface GeometricShapesProps {
	variant?: 'dot-grid' | 'grid-lines'
}

export function GeometricShapes({
	variant = 'dot-grid',
}: Readonly<GeometricShapesProps>) {
	const ref = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (variant !== 'dot-grid' || !ref.current) {
			return
		}

		const radius = window.config.portfolio.spotlightRadius
		ref.current.style.setProperty('--spotlight-radius', `${radius}px`)

		const handleMouseMove = (e: MouseEvent) => {
			if (ref.current) {
				ref.current.style.setProperty('--mouse-x', `${e.clientX}px`)
				ref.current.style.setProperty('--mouse-y', `${e.clientY}px`)
			}
		}

		window.addEventListener('mousemove', handleMouseMove)
		return () => window.removeEventListener('mousemove', handleMouseMove)
	}, [variant])

	const classes = ['geometric-shapes', `geometric-shapes--${variant}`]
		.filter(Boolean)
		.join(' ')

	return (
		<div
			aria-hidden='true'
			className={classes}
			data-testid='geometric-shapes'
			ref={ref}
		/>
	)
}
